import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { SignalRService } from './signalr.service';
import { SignalRWebService } from './signalr-web.service';
import { SignalRAndroidService } from './signalr-android.service';
import { PlatformService } from '../platform/platform.service';
import { CustomLoaderService } from 'src/app/shared/custom-loader/custom-loader.service';

const SignalRServiceFactory = (apiService: ApiService, customLoaderService: CustomLoaderService, platformService: PlatformService) =>
    isAndroidApp() ? 
    new SignalRAndroidService(apiService, platformService, customLoaderService) : new SignalRWebService(apiService, platformService, customLoaderService);


const isAndroidApp = (): boolean => {
    const androidApp = localStorage.getItem('ANDROID_APP');
    const androidId = localStorage.getItem('ANDROID_ID');
    //return !!androidApp && !!androidId;
    return window.location.href.lastIndexOf("https://appassets.androidplatform.net") > -1;
}

export const SignalRServiceProvider = { 
    provide: SignalRService,
    useFactory: SignalRServiceFactory,
    deps: [ApiService, CustomLoaderService, PlatformService]
};